// extracted by mini-css-extract-plugin
export default {"card":"Card_card__stjXR","cardDragging":"Card_cardDragging__4mjhR","cardTitle":"Card_cardTitle__59zcp"};